var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.59893 4.34354C9.96231 3.58828 11.0378 3.58828 11.4012 4.34354L17.8338 17.7135C18.1532 18.3774 17.6694 19.1471 16.9327 19.1471H4.06744C3.33069 19.1471 2.84689 18.3774 3.16631 17.7135L9.59893 4.34354Z",
    fill: "#968100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.426216 15.7747L7.85275 2.10262C8.41327 1.15901 9.40322 0.595459 10.5008 0.595459C11.5984 0.595459 12.5883 1.15901 13.1489 2.10262C13.1531 2.10984 13.1566 2.11706 13.1609 2.12428L20.5627 15.7531C21.1353 16.7166 21.1461 17.8737 20.5922 18.848C20.0371 19.8229 19.0369 20.4044 17.9153 20.4044H3.12734C2.00569 20.4044 0.964466 19.8229 0.409361 18.848C-0.144514 17.8737 -0.133728 16.7165 0.426216 15.7747ZM11.7325 6.85563C11.7325 6.17535 11.181 5.62393 10.5008 5.62393C9.82052 5.62393 9.2691 6.17539 9.2691 6.85563V11.7825C9.2691 12.4627 9.82056 13.0142 10.5008 13.0142C11.181 13.0142 11.7325 12.4626 11.7325 11.7825V6.85563ZM10.5008 17.941C11.5196 17.941 12.3484 17.1123 12.3484 16.0935C12.3484 15.0747 11.5196 14.2459 10.5008 14.2459C9.48202 14.2459 8.65325 15.0747 8.65325 16.0935C8.65321 17.1122 9.48197 17.941 10.5008 17.941Z",
    fill: "#FFDE17"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", null)))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.30e6d417.svg";
export { ForwardRef as ReactComponent };